export default __webpack_public_path__ + "static/media/certificate_for_stationery.3f6c2fa1.png";